export const mapButtonCircleViewToLoaderView = {
    primary: "primaryOnColor",
    custom: "custom",
    secondary: "primary",
    "primary-on-color": "custom",
    "secondary-on-color": "primaryOnColor",
    "on-image": "primaryOnColor",
    floating: "primary",
} as const;
